/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql, navigate } from "gatsby"
import '../../node_modules/aos/dist/aos.css';
import Header from "./header"
import AskAi from "./askai"
import { Link } from "gatsby"
import coloredLogo from "../images/new_website/invimaticColorLogo.svg";
import logo from "../images/new_website/logo.svg"
import iso from "../images/ISO-invimatic.svg"
import valuedPartners from "../images/valued-partners.svg"
// import facebook from "../images/new_website/icons/social-icons/facebook.svg"
import linkedIn from "../images/new_website/icons/social-icons/linkedIn.svg"
import indialogo from "../images/new_website/icons/indialogo.svg"
import usalogo from "../images/new_website/icons/usalogo.svg"
import mail from "../images/new_website/icons/social-icons/mail.svg"
import instagram from "../images/new_website/icons/social-icons/instagram.svg"
import * as allImages from '../utils/images';
// import loadable from '@loadable/component'
import PropTypes from "prop-types"
import "./layout.css"
// const AOS = loadable(() => import('aos'))
import ScrollToTop from "react-scroll-to-top"
import { Container, useMediaQuery, useTheme, Grid, Stack, Box, Typography } from "@mui/material"
import { useLocation } from "@reach/router";
import Face6Icon from '@mui/icons-material/Face6';
import { useState } from "react";


const Layout = ({ children, showBlueNavbar, showBlackNavbar, topPromotab, schema, faqSchema }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));

  let AOS;
  const data = useStaticQuery(graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `)
  
  React.useEffect(() => {
    /**
     * Server-side rendering does not provide the 'document' object
     * therefore this import is required either in useEffect or componentDidMount as they
     * are exclusively executed on a client
     */
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  React.useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  React.useEffect(() => {
    if (window.Analytics) {
      window.Analytics.page();
    }
  }, [location.href]);

  const [showAskAi, setShowAskAi] = useState(false);
  React.useEffect(() => {
    // Set a timeout to show the AskAi component after 10 seconds
    const timeout = setTimeout(() => {
      setShowAskAi(true);
    }, 1000);

    // Clean up the timeout if the component is unmounted before the timeout finishes
    return () => clearTimeout(timeout);
  }, []);


  return (
    <>
    {/* TO DO: uncomment below ask ai if need to be shown */}
      {/* {showAskAi && <AskAi />} */}

      <ScrollToTop smooth top={100} className="upArrowDirection" />
      {/* <section className='topPromotab'>
        <p>
          Come Meet Us {""}
          <span style={{ color: '#8bccff' }}>
            <a href="/cohuman-solution/">Beyond the BOT:Co-Human=AI+RPA</a>
          </span>
        </p>
        <Button variant="link" className="p-0 ml-2" href="/cohuman-solution/">
          <img src={allImages.promoArrow} alt="Promo Arrow" />
        </Button>
      </section> */}

      {topPromotab ? <section className='topPromotab'>
        <p>
          The 2025 SaaS Playbook: How Leading Companies Are Scaling Efficiently {" "}
          <span stopPromotabtyle={{ color: '#8bccff' }}>
            <a href="https://www.linkedin.com/posts/invimatic_saas-soc2-compliance-activity-7312490067388723201-yPdV?utm_source=share&utm_medium=member_desktop&rcm=ACoAACtd6e8BeO2SqdSRyXnp7IJe_S-y0RvnodI" target="_blank">Trending Newsletter</a>
          </span>
        </p>
      </section> : ""}

      <Header siteTitle={data.site.siteMetadata?.title || `Title`} showBlueNavbar={showBlueNavbar} showBlackNavbar={showBlackNavbar} topPromotab={topPromotab}/>

      <div>
        <main className="main-content">{children}</main>
        <footer>
          <div className="FooterComponent">
            <section className="footer-section">
              <Container maxWidth="xl" className="footerWrapper mainWrapper">
                <Stack 
                  justifyContent="space-between" 
                  display="flex" 
                  flexDirection={isMobile ? "column" : "row"} 
                  alignItems="center" 
                  sx={{marginBottom: "20px"}}
                >
                  <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <img src={iso} alt="ISO  27001:2022 certification Invimatic"/>
                    <Typography fontSize="22px !important" fontWeight="bold">ISO 27001:2022 Certified Company</Typography>
                  </Box>
                  <Box display="flex" flexDirection="column" sx={isMobile ? {marginTop: "20px", marginBottom: "15px"} : {}}>
                    <Typography 
                      fontSize="20px !important"
                      fontWeight="bold"
                      width="100%" 
                      textAlign={isMobile ? "center" : "right"}
                      marginBottom="10px"
                    >
                        Our Valued Partners
                    </Typography>
                    <img src={valuedPartners} width="100%" alt="Valued partner UI path Vanta Drata AWS " />
                  </Box>
                </Stack>
                <div className="dividerTop" style={{top: isMobile ? "0px" : "25px"}}></div>                  
                
                <Stack justifyContent="space-between" className="menuSection" sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>

                  {isMobile ?
                    <>
                      <div className="menusAll">
                        <Grid container spacing={2} rowGap={1}>
                          <Grid item xs={6}>
                            <div className="menuList">
                              <h4>Company</h4>
                              <div className="d-flex">
                                <p><a href="/about#about_main_section/">About Us</a></p>
                                <p><a href="/case-studiesdata/">Case Studies</a></p>
                                <p><a href="/blog/">Blogs</a></p>
                                <p><a href="/whitepapers/">White Paper</a></p>
                                <p><a href="/exclusives/">SOC 2 Exclusives</a></p>
                                <p><a href="/invimatic-knowledge-centre-tech-trends/">Knowledge Articles</a></p>
                                <p><a href="/careers/">Careers</a></p>
                                <p><a href="/contact/">Contact</a></p>
                                <p><a href="/write-for-us-technology/">Write For Us</a></p>
                                <p><a href="/press-releases/">Press Release</a></p>
                                <p><a href="/magazine/">Magazine</a></p>
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={6}>
                            <div className="menuList">
                              <h4>Our Industries</h4>
                              <div className="d-flex">
                                <p><a href="/transforming-logistics-and-inventory-management/">Supply Chain Logistics &<br/> Manufacturing</a></p>
                                <p><a href="/dealer-management-system-software-solutions/">Automotive & Transportation</a></p>
                                <p><a href="/digital-transformation-in-travel-hospitality/">Travel & Hospitality</a></p>
                                <p><a href="/retail-software-solutions/">Retail</a></p>
                                <p><a href="/high-tech-cloud-security/">HiTech</a></p>
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <div className="menuList">
                                <h4>Our Services</h4>
                                <Box display="flex" sx={{flexDirection: "row !important", gap: "30px !important", justifyContent: "space-between" }}>
                                  <div className="mobile-service-block">
                                    <p><a href="/ui-ux-design-solutions/">UI/UX</a></p>
                                    <p><a href="/solution-mobile-application/">Mobile Applications</a></p>
                                    <p><a href="/saas-application/">Web Applications</a></p>
                                    <p><a href="/quality-assurance-solutions/">Quality Assurance</a></p>
                                    <p><a href="/devsecops/">DevSecOps</a></p>
                                  </div>
                                  <div className="mobile-service-block">
                                    <p><a href="/solution-api-dev-integration/">API Dev & Integrations</a></p>
                                    <p><a href="/saas-integration-platform/">Market Place Application</a></p>
                                    <p><a href="/24-7-saas-support-system/">24/7 Support Services</a></p>
                                    <p><a href="/soc-2-compliance-saas-solutions/">SOC2 Compliance</a></p>
                                    <p><a href="/it-staff-augmentation-services-saas/">Staff Augmentation</a></p>
                                  </div>
                                </Box>
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <div className="countrylogo">
                              <Box display="flex" flexWrap="wrap" alignItems="center" gap={1} fontSize={14}>
                                <span>
                                  <img src={usalogo} alt="Country Logo" style={{ marginRight: '6px' }} />
                                  <span><strong>Delaware:</strong> 16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex</span>
                                </span>
                                <span>
                                  <img src={indialogo} alt="Country Logo" style={{ marginRight: '6px' }} />
                                  <span><strong>Pune:</strong> Office no. 302, 305, Gera - 77, Kalyani Nagar, Pune - 411006</span>
                                </span>
                              </Box>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </>
                    :
                    <div className="menusAll d-flex">

                      <div className="about" style={{width: "22%"}}>
                        <Link to="/" className="navbar-brand">
                          <img src={coloredLogo} className="logo-wrapper" alt="Company Logo" />
                        </Link>
                        <Box display="flex" flexDirection="row" alignItems="flex-start" sx={{width: "90%", fontSize: "14px"}}>
                          <img src={usalogo} alt="Country Logo" style={{ marginRight: '6px', marginTop: '5px'}} />
                          <span style={{lineHeight: "26px"}}><strong>Delaware:</strong> 16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex</span>
                        </Box>
                        <Box display="flex" flexDirection="row" alignItems="flex-start" sx={{width: "82%", fontSize: "14px"}}>
                          <img src={indialogo} alt="Country Logo" style={{ marginRight: '6px', marginTop: '5px'}} />
                          <span style={{lineHeight: "26px"}}><strong>Pune:</strong> Office no. 302, 305, Gera - 77, Kalyani Nagar, Pune - 411006</span>
                        </Box>
                        <Box display="flex" style={{marginTop: "13px", gap: "20px"}}>
                          <a href="mailto:contact@invimatic.com" target="_blank"> <img src={mail} alt="email" /></a>
                          <a href="https://www.linkedin.com/company/invimatic/" target="_blank"> <img src={linkedIn} alt="envelop" /></a>
                          <a href="https://www.instagram.com/invimatic_technologies/" target="_blank"> <img src={instagram} alt="envelop" /></a>
                        </Box>
                      </div>

                      <div className="menuList" style={{width: "13%"}}>
                        <h4>More</h4>
                        <hr style={{marginTop: 0}}/>
                        <div className="d-flex">
                          <p><a href="/about#about_main_section/">About Us</a></p>
                          <p><a href="/careers/">Careers</a></p>
                          <p><a href="/contact/">Contact</a></p>
                          <p><a href="/invimatic-knowledge-centre-tech-trends/">Knowledge Articles</a></p>
                          <p><a href="/write-for-us-technology/">Write For Us</a></p>
                          <p><a href="/press-releases/">Press Release</a></p>
                          <p><a href="/magazine/">Magazine</a></p>
                        </div>
                      </div>
                      
                      <div className="menuList" style={{width: "12%"}}>
                        <h4>Insights</h4>
                        <hr style={{marginTop: 0}}/>
                        <div className="d-flex">
                          <p><a href="/blog/">Blogs</a></p>
                          <p><a href="/case-studiesdata/">Case studies</a></p>
                          <p><a href="/whitepapers/">White Paper</a></p>
                          <p><a href="/exclusives/">SOC 2 Exclusives</a></p>
                        </div>
                      </div>

                      <div className="menuList"  style={{width: "18%"}}>
                        <h4>Our Industries</h4>
                        <hr style={{marginTop: 0}}/>
                        <div className="d-flex">
                          {/* <p><a href="/industries-fintech#fintech_industry_main_section/">FinTech</a></p>
                          <p><a href="/industries-hitech#hitech_industry_main_section/">HiTech</a></p>
                          <p><a href="/industries-healthtech#healthtech_industry_main_section/">HealthTech</a></p>
                          <p><a href="/industries-edtech/">EdTech</a></p>
                          <p><a href="/industries-martech#martech_industry_main_section/">MarTech</a></p> */}
                          <p><a href="/transforming-logistics-and-inventory-management/">Supply Chain Logistics & Manufacturing</a></p>
                          <p><a href="/dealer-management-system-software-solutions/">Automotive & Transportation</a></p>
                          <p><a href="/digital-transformation-in-travel-hospitality/">Travel & Hospitality</a></p>
                          <p><a href="/retail-software-solutions/">Retail</a></p>
                          <p><a href="/high-tech-cloud-security/">HiTech</a></p>
                        </div>
                      </div>

                      <div className="menuList"  style={{width: "32%"}}>
                        <h4>Our Services</h4>
                        <hr style={{marginTop: 0}}/>
                        <div style={{display: "flex", flexDirection: "row", gap: "2rem"}}>
                          <div className="d-flex" style={{gap: "20px"}}>
                            <p><a href="/ui-ux-design-solutions/">UI/UX</a></p>
                            <p><a href="/solution-mobile-application/">Mobile Applications</a></p>
                            <p><a href="/saas-application/">Web Applications</a></p>
                            <p><a href="/quality-assurance-solutions/">Quality Assurance</a></p>
                            <p><a href="/devsecops/">DevSecOps</a></p>
                          </div>
                          <div className="d-flex" style={{gap: "20px"}}>
                            <p><a href="/solution-api-dev-integration/">API Dev & Integrations</a></p>
                            <p><a href="/saas-integration-platform/">Market Place Application</a></p>
                            <p><a href="/24-7-saas-support-system/">24/7 Support Services</a></p>
                            <p><a href="/soc-2-compliance-saas-solutions/">SOC2 Compliance</a></p>
                            <p><a href="/it-staff-augmentation-services-saas/">Staff Augmentation</a></p>
                          </div>
                        </div>
                      </div>

                       {/* <div className="menuList"  style={{width: "20%"}}>
                        <Box>
                          <h4>Customer Acquisition</h4>
                          <div className="d-flex">
                            <p><a href="/ai-llm/">AI / LLM</a></p>
                            <p><a href="/services-rpa/">RPA</a></p>
                            <p><a href="/sso-solution/">Single Sign On (SSO)</a></p>
                          </div>
                        </Box>
                      </div> */}

                      {/* TO DO: below comment is for Saas aplication and its related sub section in same page */}
                      {/* <div className="menuList"  style={{width: "15%"}}>
                        <h4>Sustainability</h4>
                        <div className="d-flex">
                          <div className="div-menu-list"
                            onClick={()=>{
                                navigate("/saas-implementation", {
                                    state: {
                                        navigateId: "salesforceSect"
                                    }
                                });
                            }}
                          >
                              Salesforce
                          </div>
                          <div className="div-menu-list"
                              onClick={()=>{
                                  navigate("/saas-implementation", {
                                      state: {
                                          navigateId: "creatioSect"
                                      }
                                  });
                              }}
                          >
                              Creatio
                          </div>
                          <div className="div-menu-list"
                              onClick={()=>{
                                  navigate("/saas-implementation", {
                                      state: {
                                          navigateId: "uipathSect"
                                      }
                                  });
                              }}
                          >
                              UiPath
                          </div>
                        </div>
                      </div> */}
                    </div>
                  }
                </Stack>

                <Box className="dividerTop" display={isMobile ? "block" : "flex"} alignItems="center">
                  <p className={isMobile ? "text-center" : ""} style={{marginTop: "13px", marginRight: "10px", fontSize: "14px"}}>&copy; 2025, Invimatic Technologies Pvt. Ltd. | All Rights Reserved.
                  </p>
                  <p className={isMobile ? "text-center" : ""} style={{marginTop: "13px",fontSize: "14px"}}>
                    <Link
                      href="/privacy-policy/"
                      style={{
                        color: "#000000",
                        textDecoration: "underline",
                        fontWeight: 700,
                      }}
                    >
                      Privacy Policy
                    </Link>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <Link
                      href="/terms-of-use/"
                      style={{
                        color: "#000000",
                        textDecoration: "underline",
                        fontWeight: 700,
                      }}
                    >
                      Terms of Use
                    </Link>
                  </p>
                </Box>

              </Container>
            </section>
          </div>
        </footer >
      </div >

      {schema ? <script type="application/ld+json">{JSON.stringify(schema)}</script> : ""}
      {faqSchema ? <script type="application/ld+json">{JSON.stringify(faqSchema)}</script> : ""}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout